// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FashionInspiration-components-newExplorationDialog-NewExplorationDialog-module-asterisk::after {
	color: var(--AlertRed);
	content: " *";
}
`, "",{"version":3,"sources":["webpack://./src/FashionInspiration/components/newExplorationDialog/NewExplorationDialog.module.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,aAAa;AACd","sourcesContent":[".asterisk::after {\n\tcolor: var(--AlertRed);\n\tcontent: \" *\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"asterisk": `FashionInspiration-components-newExplorationDialog-NewExplorationDialog-module-asterisk`
};
module.exports = ___CSS_LOADER_EXPORT___;
